/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StudentProgressRow } from './StudentProgressRow';
import {
    StudentProgressRowFromJSON,
    StudentProgressRowFromJSONTyped,
    StudentProgressRowToJSON,
    StudentProgressRowToJSONTyped,
} from './StudentProgressRow';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface StudentsProgressWidgetData
 */
export interface StudentsProgressWidgetData {
    /**
     * 
     * @type {Array<StudentProgressRow>}
     * @memberof StudentsProgressWidgetData
     */
    items: Array<StudentProgressRow>;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof StudentsProgressWidgetData
     */
    total: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the StudentsProgressWidgetData interface.
 */
export function instanceOfStudentsProgressWidgetData(value: object): value is StudentsProgressWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function StudentsProgressWidgetDataFromJSON(json: any): StudentsProgressWidgetData {
    return StudentsProgressWidgetDataFromJSONTyped(json, false);
}

export function StudentsProgressWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): StudentsProgressWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(StudentProgressRowFromJSON)),
        'total': ApiUserTasksGetPageParameterFromJSON(json['total']),
    };
}

export function StudentsProgressWidgetDataToJSON(json: any): StudentsProgressWidgetData {
    return StudentsProgressWidgetDataToJSONTyped(json, false);
}

export function StudentsProgressWidgetDataToJSONTyped(value?: StudentsProgressWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(StudentProgressRowToJSON)),
        'total': ApiUserTasksGetPageParameterToJSON(value['total']),
    };
}

